export var SELECT_TEST_DAY = 'SELECT_TEST_DAY';
export var selectTestDay = function selectTestDay(selectedTestDay) {
  return {
    type: SELECT_TEST_DAY,
    selectedTestDay: selectedTestDay
  };
};